import { createApp } from 'vue'
import App from './App.vue'
import vuetify from '../common/plugins/vuetify'
import store from '../store/index.js'

import { usersApi } from '../api/api.users.service'

const apiService = {
  usersApi: usersApi,
}

var app = createApp(App)

app.config.globalProperties.apiService = apiService

app.use(vuetify).use(store).mount('#ec-login-form')
